import { createFileRoute } from '@tanstack/react-router';

import { EditProfile } from '../-components/EditProfile';
import { EditProfileError } from '../-components/error/EditProfileError';
import { EditProfileSkeleton } from '../-components/pending/EditProfileSkeleton';
import { useEditProfile } from '../-logic/useEditProfile';
import { EditProfileContext } from '../-logic/useEditProfileContext';

export const Route = createFileRoute('/_authed/profile/edit/')({
  component: EditProfilePage,
  errorComponent: EditProfileError,
  pendingComponent: EditProfileSkeleton,
});

function EditProfilePage() {
  return (
    <EditProfileContext.Provider value={useEditProfile()}>
      <EditProfile />
    </EditProfileContext.Provider>
  );
}
